import { useTranslation } from "react-i18next";
import { useRemoteQuery } from "../../../hooks/Remote/useRemote/useRemoteQuery";
import type {
  ManagementDashboardQueryParams,
  ManagementDashboardResponse
} from "../typings/management-dashboard.types";

export function useRemoteFetchManagementDashboard(
  params: ManagementDashboardQueryParams,
  enabled = true
) {
  const { t } = useTranslation();

  return useRemoteQuery<ManagementDashboardResponse>({
    queryKey: ["management-dashboard", params],
    url: "/report/management-dashboard",
    params,
    enabled:
      enabled &&
      !!params.periodMode &&
      !!params.periodStart &&
      (params.periodMode !== "custom" || !!params.periodEnd),
    snackbarTextOnFail: t("_management_loadError"),
    keepPreviousData: true
  });
}
